import { FormConfiguration } from '@prisma/client'
import React, { useEffect, useMemo, useState } from 'react'
import { useClearParams } from '~/features/shared/hooks'
import { Toolbox } from '~/plugins/toolbox/shared'
import { StepType } from '../../../common/types'
import { useNavigationParams } from '../../hooks/useNavigationParams'
import { ViewerStep } from '../ViewerStep'

type Props = {
  isReadonly?: boolean
  values: any
  valuesConfiguration?: any
  formConfiguration: FormConfiguration
  onChange: (values: any) => void
  onSubmitStep: (values: any, step?: StepType) => void
  onSubmitForm: (values: any, step?: StepType) => void
}

export const Viewer: React.FC<Props> = ({
  isReadonly = false,
  values = {},
  valuesConfiguration,
  formConfiguration,
  onChange,
  onSubmitStep,
  onSubmitForm,
}) => {
  const [valuesLocal, setValuesLocal] = useState()

  useEffect(() => {
    setValuesLocal(values ?? {})
  }, [])

  const { step, nextStep, previousStep, isLastStep } = useNavigationParams({
    values: valuesLocal,
    configuration: formConfiguration?.configuration as any,
    onSubmitStep,
    onSubmitForm,
  })

  useClearParams()

  const handleChange = (valuesUpdated: any) => {
    if (isReadonly) {
      return
    }
    const valuesEnsured = Toolbox.Utility.trimNullValues(valuesUpdated)
    onChange(valuesEnsured)
  }

  const handleChangeDebounced = useMemo(() => {
    return Toolbox.Utility.debounce(handleChange, 500)
  }, [onChange])

  const handleSubmit = (valuesUpdated: any) => {
    setValuesLocal(valuesUpdated)
    nextStep(valuesUpdated)
  }

  return (
    <>
      {step && (
        <ViewerStep
          isReadonly={isReadonly}
          isLastStep={isLastStep}
          valuesConfiguration={valuesConfiguration}
          values={valuesLocal}
          step={step}
          onChange={valuesUpdated => {
            if (!isReadonly) {
              setValuesLocal(valuesUpdated)
              handleChangeDebounced(valuesUpdated)
            }
          }}
          onChangeInstant={handleChange}
          onSubmit={handleSubmit}
          onBack={previousStep}
        />
      )}
    </>
  )
}
